import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

const futurePhases = [
  'Módulo de ingresos y rentabilidad',
  'Análisis de márgenes por producto',
  'Predicciones y alertas inteligentes',
  'Integración con inventario y operaciones',
  'Copiloto financiero (asistente con IA)',
];

const EscalabilidadSection = () => {
  const theme = useTheme();

  return (
    <Card
      variant="outlined"
      sx={{
        py: 4,
        px: 3,
        borderRadius: 2,
        bgcolor: theme.palette.alternate.main,
        borderLeft: 4,
        borderColor: theme.palette.primary.main,
      }}
    >
      <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 700 }}
          variant="overline"
          color="primary"
          display="block"
          gutterBottom
        >
          Escalabilidad
        </Typography>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          Fases futuras
        </Typography>
        <Typography variant="body1" color="textSecondary" paragraph>
          El sistema está diseñado para evolucionar hacia:
        </Typography>
        <Grid container spacing={2}>
          {futurePhases.map((phase, i) => (
            <Grid item xs={12} sm={6} key={i}>
              <Box
                display="flex"
                alignItems="center"
                sx={{
                  py: 1,
                  px: 2,
                  borderRadius: 1,
                  bgcolor: theme.palette.primary.main + '14',
                  border: `1px solid ${theme.palette.primary.main}33`,
                }}
              >
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    bgcolor: theme.palette.primary.main,
                    mr: 1.5,
                  }}
                />
                <Typography variant="body2" fontWeight={500}>
                  {phase}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default EscalabilidadSection;
